module.exports = __webpack_public_path__ + "img/Flag_of_Chile.a27c8c90.svg";